export enum GamesOpenSessionsKind
{
    Real = 0,
    FreePlay = 1,
    All = 2
}